import React from 'react'
import { Provider } from 'react-redux'

const addStore = ({ store }) => {
    return Component =>
        ({ ...props }) =>
            (
                <Provider store={store}>
                    <Component {...props} dispatch={store.dispatch} />
                </Provider>
            )
}

export default addStore
